import { render, staticRenderFns } from "./ProfilePersonalInfo.vue?vue&type=template&id=4085ecae&scoped=true"
import script from "./ProfilePersonalInfo.vue?vue&type=script&lang=ts"
export * from "./ProfilePersonalInfo.vue?vue&type=script&lang=ts"
import style0 from "./ProfilePersonalInfo.vue?vue&type=style&index=0&id=4085ecae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4085ecae",
  null
  
)

export default component.exports